import { render, staticRenderFns } from "./select_order.vue?vue&type=template&id=87fa533c&scoped=true&"
import script from "./select_order.vue?vue&type=script&lang=js&"
export * from "./select_order.vue?vue&type=script&lang=js&"
import style0 from "./select_order.vue?vue&type=style&index=0&id=87fa533c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fa533c",
  null
  
)

export default component.exports